export default "__VITE_ASSET__Cky3HJoI__"